$(".cart-pop-btn").click(function () {
  $(".custom-popup-holder").addClass("pop-up-opener");
  $(".close-btn").removeClass("pop-up-opener");
  $('body').css("overflow-y", "hidden");
});

$(".close-btn").click(function () {
  $(".custom-popup-holder").removeClass("pop-up-opener");
  $('body').css("overflow-y", "scroll");
});

$(".overlay").click(function () {
  $(".custom-popup-holder").removeClass("pop-up-opener");
  $('body').css("overflow-y", "scroll");
});


function removeItem (id)
{
  $.post('/cart/update.js', 'updates['+id+']=0');
  setTimeout(function(){
    getCart();
  }, 200);
}

$('.cart__form').submit(function() {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('.cart__form').serialize(),
    success: function(res){
      $('body').css("overflow-y", "hidden");
      getCart();
    },
    error: function(err){
      console.log(err);
      alert('something went wrong');
    }
  });
  return false;
});


function addGift (id)
{
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json', 
    data: {id: id, quantity: 1},
    success: function(res){
      getCart();
    },
    error: function(err){
      console.log(err);
      alert('something went wrong');
    }
  });
}

function increment(id, element){
  var Iqty = parseInt(element);
  Iqty += 1;
  var giftbox_qty = element;
  var flag = true;
  
  if (id == 39553846018245)
  {
    var bags_counter = 0;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      async: false,
      dataType: 'json',
      success: function(cart){
        $.each(cart.items, function(index, item){
          var small_case_title = item.title.toLowerCase();
          if (!small_case_title.includes('charity') && !small_case_title.includes('exclusive') && !small_case_title.includes('exklusive'))
          {
            bags_counter += item.quantity;
          }
        });
        if (giftbox_qty >= bags_counter)
        {
          alert('You cant add more gift boxes than bags');
          flag = false;
        }
      }
    });
  }

  if (flag == false)
  {
    return false;
  }
  
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    async: false,
    cache: false,
    data: {
      quantity: Iqty,
      id: id
    },
    success: function(res){
      getCart();
    },
    error: function(err){
      console.log(err);
      alert('something went wrong');
    }
  });
}


function decrement(id, element, type){
  var giftbox_qty = 0;
  var flag = true;
  if (type.includes('vegan'))
  {
    var bags_counter = 0;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      async: false,
      dataType: 'json',
      success: function(cart){
        $.each(cart.items, function(index, item){
          var small_case_title = item.title.toLowerCase();
          if (!small_case_title.includes('charity') && !small_case_title.includes('exclusive') && !small_case_title.includes('exklusive'))
          {
            bags_counter += item.quantity;
          }
          if (small_case_title.includes('exclusive') || small_case_title.includes('exklusive'))
          {
            giftbox_qty = item.quantity;
          }
        });
        if (giftbox_qty >= bags_counter)
        {
          flag = false;
        }
      }
    });
  }
  
  var qty = parseInt(element) - 1;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'id=' + id + '&quantity='+qty+'',
    async: false,
    cache: false,
    dataType: 'json',
    success: function() {     
      	getCart();
    },
    error: function(err){
      console.log(err);
    }
  });
    
  if (flag == false)
  {
    $('.gift-box-decrement').trigger('click');
  }
}

function getCart ()
{
  var cart;
  var url;
  if (window.location.pathname.includes('de'))
    var url = 'https://melinabucher.com/de/cart.js';
  else
    var url = '/cart.js';

  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    success: function(full_cart){
      cart = full_cart;
      populateCart(cart);
      if ($(".custom-popup-holder").hasClass('pop-up-opener') == false)
      {
        $(".custom-popup-holder").addClass("pop-up-opener");
        $(".close-btn").removeClass("pop-up-opener");
      }
    }
  })
}

function populateCart (cart)
{
  var charity_amount = 1;
  var charity_amount_count = 0;
  var currency = theme.moneyFormat.split('{')[0];
  var giftbox = false; // new variable, true if giftbox is in the cart, false if it is not in the 
  var show_gift_box = false;

  $('.cart-list').empty();
  $('.cart-drawer-item-count span, .cart-drawer-item-count p span').text(cart.item_count);
  $('.sub-total-row span').text(currency+cart.total_price/100); // can we add a space separator to the total price?
  $('.charity_amount').text(currency+charity_amount_count);
  
  if (charity_amount_count == 0)
  {
    $('.cart-drawer-item-donation p').hide();
  }

  $.each(cart.items, function(index, item){
    var small_case_title = item.title.toLowerCase();
    var product_type =  "'" + item.product_type.toLowerCase() + "'";
    var is_gift;
    
    if (small_case_title.includes('charity'))
    {
      charity_amount = item.quantity * 10;
      charity_amount_count += charity_amount
      $('.cart-drawer-item-donation p').show();
    }

    $('.charity_amount').text(currency+charity_amount_count);
    if (small_case_title.includes('caramel')) // for the caramel sweater, the correct img is not shown by default. so I added this code to replace the image by the correct one
    {
      var itemimg = '//cdn.shopify.com/s/files/1/0047/1003/9652/products/MELINABUCHER_Bailey_caramel_front_27742545-7430-4077-97e0-b22994e75b50.png';
    }
    else
    {
      var itemimg = item.image;
  	}
    if (small_case_title.includes('exclusive') || small_case_title.includes('exklusive')) // check whether giftbox is in the cart
    {
      giftbox = true; // if yes, turn giftbox var to true
      is_gift = 'gift-box-decrement';
    }
    var small_case_type = item.product_type.toLowerCase();
    if (small_case_type.includes('vegan') || small_case_type.includes('handbag'))
    {
      show_gift_box = true;
    }
    var short_title = item.title.split(' - '); // this is a new variable to convert the item.title to item.product.title (no color, size etc. in the title)
    var html = "";
    html = '<li><div class="pic-holder"><a href="'+ item.url +'"><img src="'+ itemimg +'" alt=""></a></div>\
             <div class="product-meta"><h3><a href="'+ item.url +'">'+ short_title[0] +'</a></h3>\
             <div class="product-varients">'
            $.each(item.options_with_values, function(j, opv){
                html+= '<div class="product-options"><div class="varient-row">\
                <span>'+opv.value.replace("-", " ")+'</span></div></div>'
            });
    html += '<div class="select-row">\
						   <div class="qtydiv">\
                           <label for="Quantity" class="quantity-selector">Quantity</label>\
                           <div class="qtybox">\
                           <span class="btnqty qtyminus icon icon-minus '+ is_gift +'" onclick="decrement('+item.id+','+item.quantity+',' + product_type +')">-</span>\
                           <div class="number-count">\
                           <input type="text" id="quantity" name="quantity" value="'+ item.quantity +'" min="1" class="quantity-selector quantity-input" readonly>\
                           </div>\
						   <span class="btnqty qtyplus icon icon-plus" onclick="increment('+item.id+','+item.quantity+')">+</span>\
                           </div>\
                           </div>\
                           </div>\
                           </div>\
                           </div>\
                           <div class="cart-price">\
                           <span class="txt-price">'+currency+ item.price/100 +'</span>\
                           </div>\
                           </li>';
        
    $('.cart-list').append(html);
  });
  console.log(show_gift_box, 'show_gift_box')
   	if (giftbox == false && cart.item_count > 0 && show_gift_box == true)
    {
      var gift_html = '<li><div class="pic-holder">\
            <a href=""><img src="//cdn.shopify.com/s/files/1/0047/1003/9652/products/MELINABUCHER_products_exclusive_gift_box.jpg" alt="EXCLUSIVE GIFT BOX"></a>\
          </div>\
          <div class="product-meta">\
            <h3 style="color:#16161a">EXCLUSIVE GIFT BOX</h3>\
          </div>\
          <div class="cart-price">\
            <span class="txt-price">'+currency+'0</span>\
          </div>\
          <div class="cart-add-special-item">\
			<button id="cart__button" onclick=addGift(39553846018245) type="submit" name="add" class="button button-slide-left" style="width:100%" data-add-to-cart="">Get</button>\
          </div></li>';
        
      $('.cart-list').append(gift_html);
    }
}

// Remove button below txt-price has been eliminated for now. Here's the code as a backup:  <button class="remove-lineItem-btn" onclick="removeItem('+ item.id +')">Remove</button>\

